import React from 'react';
// material
import { Stack, Container, Typography, Card, Box } from '@mui/material';
// components
import Page from '../../components/Page';
import SettingsTheme from '../../components/settings/form/theme';

export default function PageSettingsTheme() {
  return (
    <Page title="Theme" path="/settings/theme">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4">Theme Settings</Typography>
        </Stack>
        <Card>
          <Box sx={{ p: 3 }}>
            <SettingsTheme />
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
